import { render, staticRenderFns } from "./ed-portal-info-section.vue?vue&type=template&id=e4159a82&scoped=true&"
import script from "./ed-portal-info-section.ts?vue&type=script&lang=js&"
export * from "./ed-portal-info-section.ts?vue&type=script&lang=js&"
import style0 from "./ed-portal-info-section.scss?vue&type=style&index=0&id=e4159a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4159a82",
  null
  
)

export default component.exports